import { useLang } from "../contexts/LanguageContext";
import { Ship, Map, FileCheck } from "lucide-react";

export function LogisticsSection() {
  const { t } = useLang();
  const points = [
    { icon: Ship, title: t.logistics.point1_title, desc: t.logistics.point1_desc },
    { icon: Map, title: t.logistics.point2_title, desc: t.logistics.point2_desc },
    { icon: FileCheck, title: t.logistics.point3_title, desc: t.logistics.point3_desc },
  ];

  return (
    <section
      id="logistics"
      data-testid="logistics-section"
      className="relative overflow-hidden text-primary-foreground"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1496347326319-2935d381b307?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMHNoaXAlMjBvY2VhbiUyMHN1bnNldHxlbnwwfHx8fDE3ODE0MzIxNDd8MA&ixlib=rb-4.1.0&q=85"
          alt="Cargo vessel in open waters"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1A120B]/85" />
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-6">
            <p className="tracking-eyebrow uppercase text-xs text-secondary mb-4">
              {t.logistics.eyebrow}
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
              {t.logistics.title}
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 self-end">
            <p className="text-base md:text-lg text-primary-foreground/80 leading-relaxed">
              {t.logistics.lead}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {points.map((p, idx) => (
            <div
              key={idx}
              data-testid={`logistics-point-${idx}`}
              className="border-t border-primary-foreground/30 pt-8 space-y-5"
            >
              <p.icon strokeWidth={1.4} size={32} className="text-secondary" />
              <h3 className="font-display text-2xl">{p.title}</h3>
              <p className="text-sm text-primary-foreground/75 leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 inline-flex items-center gap-3 border border-primary-foreground/30 px-6 py-3">
          <span className="tracking-eyebrow text-xs uppercase text-secondary">
            Maritime partner
          </span>
          <span className="font-display text-xl tracking-wide">MSC — Mediterranean Shipping Company</span>
        </div>
      </div>
    </section>
  );
}
